<div class="flex flex-col">
  <span class="font-bold text-xl">Branch Operations</span>
  <span class="font-semibold">List address and phone numbers of each branch</span>

  <div class="flex flex-row gap-4 pt-4 items-center" *ngIf="renewal">
    <span class="font-semibold text-lg">Reminder:</span>
    <span>
      Branch offices do not change the geographic services area, it's determined by parent address only
    </span>
  </div>

  <div class="flex flex-col md:flex-row items-center pt-4 gap-4" [ngClass]="isChange? '' : 'md:w-1/3' " *ngIf="!managingOperation">
    <div class="flex flex-col md:flex-row gap-1">
      <span class="font-semibold">Branch</span>
      <span class="font-semibold">Operations</span>
    </div>

    <button *ngIf="approved" type="button" mat-button color="primary" (click)="requestChange(sharedService.add, 0)">Add a Branch</button>
    <button *ngIf="isChange || !locked || renewal" type="button" mat-button color="primary" (click)="createOperation()">Add a Branch</button>

    <button *ngIf="!isChange" type="button" mat-button color="primary" (click)="getOperations(!includeArchived)">
      {{includeArchived? 'Hide Archived' : 'Show Archived'}}</button>
  </div>

  <div class="flex flex-wrap" *ngIf="!managingOperation" [@slideRight]>
    <div class="md:p-2" [ngClass]="isChange? 'w-full': 'md:w-1/2'" *ngFor="let operation of operations">
      <mat-card class="w-full">
        <mat-card-content>
          <div class="flex flex-col">
            <div class="grid grid-cols-2 gap-2 items-center" [ngClass]="locked? '' : '-mt-4'">
              <div><span>Phone: {{ operation.phone | mask:'000-000-0000' }}</span></div>
              <div class="gap-1 flex justify-self-end items-center">
                <span class="font-semibold" *ngIf="operation.archived">Archived</span>

                <button type="button" mat-button color="primary" *ngIf="!operation.archived && !locked"
                  (click)="selectOperation(operation)">Edit</button>

                <button *ngIf="approved || (renewal && !operation.adding)" type="button" mat-button color="primary"
                  (click)="requestChange(sharedService.change, operation.id)">Request Address Change</button>

                <button type="button" mat-button [color]="operation.removing? 'accent' : 'warn'" *ngIf="renewal"
                  (click)="markForRemoval(operation, !operation.removing)">
                  {{operation.removing? 'Cancel Removal' : 'Mark for Removal'}}</button>

                <button type="button" mat-button color="warn" *ngIf="approved || !locked"
                  (click)="confirmDelete(operation.id)">Delete</button>

                <button type="button" mat-icon-button [color]="operation.archived? 'primary' : 'warn'" *ngIf="!locked"
                                      (click)="archiveOperation(operation, !operation.archived)"
                                      [matTooltip]="operation.archived? 'Un-Archive Operation' : 'Archive Operation'" matTooltipShowDelay="500"
                                      matTooltipHideDelay="200">
                  <mat-icon *ngIf="!operation.archived" fontIcon="archive"></mat-icon>
                  <mat-icon *ngIf="operation.archived" fontIcon="unarchive"></mat-icon>
                </button>

              </div>
            </div>
            <div class="flex flex-row gap-2">
              <span>Distance to Agency:</span>
              <span *ngIf="operation.distance === -1">Add an address to calculate distance to the agency</span>
              <span *ngIf="operation.distance >= 0"
                    [ngClass]="operation.distance < 60? 'portal-success' : 'portal-error'">{{ operation.distance }} Miles</span>
            </div>

            <mat-checkbox *ngIf="operation.removing" labelPosition="before" checked="true" disabled="true">
              <span class="text-lg">Marked for Removal</span>
             </mat-checkbox>
             <span *ngIf="operation.distance === 0" class="portal-error">
              We were not able to calculate the distance to the agency. We will manually review this branch.
              If the branch is more than 60 miles away, it will not be approved for the agency.
            </span>
            <span *ngIf="operation.distance >= 60" class="portal-error">
              A branch operation must be fewer than 60 miles from the agency, and
              this branch appears to be more than 60 miles away.
            </span>
            <span *ngIf="operation.distance >= 60 && !isChange" class="portal-error">
              You may still submit your application, but this branch
              will not be approved for the agency. For questions
              please contact the Health Care Regulation and Quality Improvement Section
              for further assistance.
            </span>
            <address class="pt-4"
                     [entityId]="operation.id"
                     [entityType]="sharedService.branchOperation">
            </address>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <div class="flex flex-col gap-4 pt-4" [ngClass]="isChange? '' : 'md:w-1/2'" *ngIf="managingOperation" [@slideRight]>
    <mat-card>
      <mat-card-content>
        <div class="flex flex-col">
          <div class="grid grid-cols-2 gap-2 items-center">
            <div>
              <div *ngIf="operation.id === 0" class="flex flex-col md:flex-row gap-1">
                <span class="font-semibold">Add</span>
                <span class="font-semibold">Operation</span>
              </div>

              <div *ngIf="operation.id > 0" class="flex flex-col md:flex-row gap-1">
                <span class="font-semibold">Update</span>
                <span class="font-semibold">Operation</span>
              </div>
            </div>
            <div class="gap-2 flex justify-self-end items-center">
              <button type="button" *ngIf="operationForm.valid && operation.distance >= 0 && (!locked || isChange || renewal)"
                      mat-button color="primary" (click)="saveOperation()">Save</button>

              <button *ngIf="!isChange" type="button" mat-button color="warn" (click)="toggleOperationForm(false)">Close</button>
            </div>
          </div>

          <form [formGroup]="operationForm">
            <div class="flex flex-col md:flex-row gap-2 items-center">
              <mat-form-field class="md:w-1/2">
                <mat-label>Phone</mat-label>
                <input matInput formControlName="phone" mask="000-000-0000">
                <mat-error *ngIf="operationForm.get('phone').hasError('required')">
                  A phone number is required
                </mat-error>
                <mat-error *ngIf="operationForm.get('phone').hasError('pattern')">
                  Phone should match format: 000-000-0000
                </mat-error>
              </mat-form-field>
            </div>
          </form>

          <div class="flex flex-row gap-2 pt-4">
            <span>Distance to Agency:</span>
            <span *ngIf="operation.distance === -1">Add an address to calculate distance to the agency</span>
            <span *ngIf="operation.distance >= 0"
                  [ngClass]="operation.distance < 60? 'portal-success' : 'portal-error'">{{ operation.distance }} Miles</span>
          </div>
          <span *ngIf="operation.distance === 0" class="portal-error">
            We were not able to calculate the distance to the agency. We will manually review this branch.
            If the branch is more than 60 miles away, it will not be approved for the agency.
          </span>
          <span *ngIf="operation.distance >= 60" class="portal-error">
            A branch operation must be fewer than 60 miles from the agency, and
            this branch appears to be more than 60 miles away.
          </span>
          <span *ngIf="operation.distance >= 60 && !isChange" class="portal-error">
            You may still submit your application, but this branch
            will not be considered for the agency. For questions
            please contact the Health Care Regulation and Quality Improvement Section
            for further assistance.
          </span>

          <address [entityId]="operation.id"
                   [entityType]="sharedService.branchOperation"
                   [limitEntries]="true"
                   [limitTo]="1"
                   [canEdit]="!locked || isChange"
                   (updatedPhysicalAddress)="getDistanceToParent()"
                   (reportDistance)="updateLicenseDistance($event, operation)">
          </address>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
